import { FormFieldBase } from './form-field-base.model';

export class FormFieldChips extends FormFieldBase<any> {
  override controlType = 'chips';
}
